/* eslint-disable react/prop-types */
import { RouteComponentProps } from "@reach/router"
import { DocumentTitleOverride } from "@shared/primitive-components"
import { IFrame } from "./iframe"
import { usePolicyAndFleet } from "../contexts"
import { LowConnectivityBanner } from "../ui/components/LowConnectivityBanner"
import { PrevPolicyDropdown } from "../ui/components"
import { ScreenContentWithContext } from "../components/ScreenContentWithContext"

export const Claims: React.FC<RouteComponentProps> = () => {
  const { policy, connectivity } = usePolicyAndFleet()

  return (
    <>
      <ScreenContentWithContext title="Claims" PreviousPolicyDropdown={<PrevPolicyDropdown />}>
        {!!(connectivity.data || policy.connectivityRatio) && <LowConnectivityBanner policy={policy} />}
        <DocumentTitleOverride>Flock Motor | Claims</DocumentTitleOverride>
        <IFrame path={`policies/${policy.id}/claims`} />
      </ScreenContentWithContext>
    </>
  )
}
